import * as React from "react";
import { CSSProperties, ReactElement, ReactNode } from "react";
import styles from "./Card.module.scss";

type CardProps = {
  /** Content placed inside the card. */
  children: ReactNode;
  /** Extra class name(s) merged with the base card style. */
  className?: string;
  /** Inline style overrides (e.g. custom margin/padding). */
  style?: CSSProperties;
};

/**
 * Card
 * --------------------------------------------------------------------------
 * Reusable content card: white background, subtle border, rounded corners
 * and a soft shadow. Wrap any content to place it inside the card.
 *
 * Usage:
 *   import Card from "Components/Card/Card";
 *   <Card>{content}</Card>
 */
const Card = ({ children, className, style }: CardProps): ReactElement => {
  const classes = className ? `${styles.card} ${className}` : styles.card;

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
};

export default Card;
